import { render, staticRenderFns } from "./PublicSurvey.vue?vue&type=template&id=4705fe4e"
import script from "./PublicSurvey.vue?vue&type=script&lang=js"
export * from "./PublicSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports